// ==============================================================================
// CONFIGURATION SETTINGS
// Edit this file with your specific keys and preferences.
// ==============================================================================

// Venmo username for payment integration
export const VENMO_USERNAME = process.env.REACT_APP_VENMO_USERNAME || "";

// FIREBASE CONFIGURATION
// Paste the object from your Firebase Console -> Project Settings -> General -> Your Apps
export const MANUAL_FIREBASE_CONFIG = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
};
